import { z } from "zod";

import { attachmentSchema } from "./attachment";
import { cardSchema } from "./card";
import { customEmojiSchema } from "./custom-emoji";
import { contentSchema, dateSchema, filteredArray } from "./utils";

const emojiSchema = z.object({
  me: z.boolean().catch(false),
  name: z.string(),
  count: z.number(),
});

const chatMessageSchema = z.object({
  account_id: z.string(),
  media_attachments: filteredArray(attachmentSchema).catch([]),
  card: cardSchema.nullable().catch(null),
  chat_id: z.string(),
  content: contentSchema,
  created_at: dateSchema,
  emojis: filteredArray(customEmojiSchema),
  expiration: z.number().optional().catch(undefined),
  emoji_reactions: filteredArray(emojiSchema).nullable().catch(null),
  id: z.string(),
  unread: z.coerce.boolean(),
  deleting: z.coerce.boolean(),
  pending: z.coerce.boolean(),
});

type ChatMessage = z.infer<typeof chatMessageSchema>;

export { chatMessageSchema, type ChatMessage };
